import { render } from "./MainTypeOfVouchers.vue?vue&type=template&id=53fae3b4&scoped=true"
import script from "./MainTypeOfVouchers.vue?vue&type=script&lang=js"
export * from "./MainTypeOfVouchers.vue?vue&type=script&lang=js"

import "./MainTypeOfVouchers.vue?vue&type=style&index=0&id=53fae3b4&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53fae3b4"]])

export default __exports__